<template>
  <div>
    <button class="btn btn-primary mb-4" @click="$root.$emit('bv::show::modal', addUserModalId)">
      <icon class="btn-icon" name="plus-circle"></icon>
      Add User
    </button>
    <spinner v-if="loading"></spinner>
    <div v-else>
      <table class="table table-hover">
        <thead>
        <tr>
          <th></th>
          <th>Name</th>
          <th>Email</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="user in users" :key="user.id" :class="{'text-muted': userIsWaitingForDeletion(user)}">
          <td>
            <user-picture
              :user="filterUserData(user)"
              :size="30">
            </user-picture>
          </td>
          <td>
            <span v-if="userIsWaitingForDeletion(user)">
              {{user.name}}
            </span>
            <router-link v-else
                         :to="{ name: 'administration.settings.users.edit', params: {id: user.id} }"
            >
              {{user.name}}
            </router-link>
          </td>
          <td>{{user.email}}</td>
          <td class="text-right">
            <div v-if="userIsWaitingForDeletion(user)">
              <span class="badge badge-secondary text-white">Deletion in progress</span>
            </div>
            <div v-else>
              <router-link role="button" class="btn btn-outline-primary btn-sm mr-2"
                           :to="{ name: 'administration.settings.users.edit', params: {id: user.id} }">
                Edit
              </router-link>
              <a v-if="isDeleteUserAllowed(user)"
                 href="#" class="align-middle" role="button"
                 @click="openDeleteConfirm(user)"
              >
                <icon class="text-danger" name="trash"/>
              </a>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <b-pagination v-model="currentPage"
                    :total-rows="totalItems"
                    :per-page="listMaxSize"
                    :hide-goto-end-buttons="hideGoToEndButtons"
                    @change="pageChanged">
      </b-pagination>
    </div>
    <modal-confirm-delete
      :modalId="modalIdDeleteUser"
      @userDeleted="userDeleted"
      :user="userForDeletion">
    </modal-confirm-delete>
    <modal-add-user
      :modalId="addUserModalId">
    </modal-add-user>
  </div>
</template>

<script>
  import UserPicture from '@/components/common/UserPicture'
  import ConfirmDeleteUser from '@/components/administration/user/ConfirmDeleteUser'
  import AddUser from '@/components/administration/user/AddUser'
  import userService from '@/services/amio-api/user.service'
  import usersComponentService from '@/services/security/users.service'
  import 'vue-awesome/icons/trash'
  import 'vue-awesome/icons/plus-circle'
  import loadingMixin from '@/mixins/loading.mixin'

  export default {
    mixins: [loadingMixin],

    components: {
      'user-picture': UserPicture,
      'modal-confirm-delete': ConfirmDeleteUser,
      'modal-add-user': AddUser
    },

    data() {
      return {
        users: [],
        userForDeletion: {},
        modalIdDeleteUser: 'delete-user',
        addUserModalId: 'add-user',
        totalItems: null,
        listMaxSize: parseInt(process.env.VUE_APP_LIST_MAX_SIZE),
        paginationMaxSize: parseInt(process.env.VUE_APP_PAGINATION_MAX_SIZE),
        currentPage: 1
      }
    },

    computed: {
      hideGoToEndButtons() {
        return this.totalItems < parseInt(process.env.VUE_APP_PAGINATION_ITEMS_SHOW_END_BUTTONS)
      }
    },

    methods: {
      userIsWaitingForDeletion: usersComponentService.userIsWaitingForDeletion.bind(usersComponentService),
      isDeleteUserAllowed: usersComponentService.isDeleteUserAllowed,

      filterUserData(user) {
        return {
          email: user.email,
          name: user.name || user.email
        }
      },

      setData({items, totalItems}) {
        this.users = items
        this.totalItems = totalItems
      },

      pageChanged(page) {
        this.currentPage = page
        this.$router.push({query: {page: page}})
        return this.getUsers()
      },

      openDeleteConfirm(user) {
        this.userForDeletion = user
        this.$root.$emit('bv::show::modal', this.modalIdDeleteUser)
      },

      userDeleted(deletedUser) {
        usersComponentService.addUserWaitsForDeletion(deletedUser)
        this.getUsers()
      },

      getUsers() {
        const page = this.$route.query.page ? parseInt(this.$route.query.page) : this.currentPage
        this.loading = true
        // Auth0 has zero based pagination
        return userService.list({page: page - 1, per_page: this.listMaxSize})
          .then(this.setData)
          .then(() => {
            this.loading = false
            // set currentPage after totalItems are set due to b-pagination
            this.currentPage = page
          })
      }
    },

    mounted() {
      this.getUsers()
    },

    beforeRouteEnter(to, from, next) {
      next(vm => vm.getUsers())
    }
  }

</script>
